export default "__VITE_ASSET__Ddflpmkz__"